import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Button, Cell, CardTitle, DialogContainer, SelectField, TimePicker, DatePicker, Grid } from 'react-md';
import { NotificationManager } from 'react-notifications';
import ApiRequestService from '../component/ApiRequestService';
import LoadingSpinner from '../component/LoadingSpinner';
import Properties from '../component/Properties';
import QuizDropDown from '../component/QuizDropDown';
import SectionDropDown from '../component/SectionDropDown';
import { AppProperties } from '../common/function';
import CustomSegmentedControl from '../lib/components/CustomSegementedControl';
import styles from "../css/styles.css.js";

const labels = [
    { label: 'From Previous Semester', value: 'from_previous_semester', default: true },
    { label: 'From Assignment Library', value: 'from_public_library', default: false },
]

const selectedOptionsStyles = {
    color: '#FFFFFF',
    backgroundColor: '#bb0000'
};
const optionsListStyles = {
    backgroundColor: '#FFFFFF',
    color: '#bb0000'
};


const isValidDate = function (d) {
    return d instanceof Date && !isNaN(d);
}

const CopyAllQuizDialog = ({ visible, onHide, courseID, fromMatrixPage, onCompleteCopyQuiz }) => {

    let appProperties = AppProperties();
    let baseFolder = appProperties.baseFolder;

    const [loading, setLoading] = useState(false);
    const [sectionLoading, setSectionLoading] = useState(false);
    const [courseLoading, setCourseLoading] = useState(false);
    const [quizLoading, setQuizLoading] = useState(false);

    const [selectedTab, setSelectedTab] = useState("from_previous_semester");

    const [course, setCourse] = useState(undefined);
    const [courses, setCourses] = useState([]);
    const [sections, setSections] = useState([]);
    const [semesters, setSemesters] = useState([]);
    const [quizzes, setQuizzes] = useState([]);
    const [selectedQuizIds, setSelectedQuizIds] = useState([]);
    const [selectedQuizIdArray, setSelectedQuizIdArray] = useState([]);
    const [semester, setSemester] = useState(undefined);
    const [sectionsArray, setSectionsArray] = useState([]);
    const [sectionsSelected, setSectionsSelected] = useState(undefined);
    const [selectSectionID, setSelectSectionID] = useState([]);
    const [startDateAndTime, setStartDateAndTime] = useState('');
    const [endDateAndTime, setEndDateAndTime] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    let startDateLocal = moment(startDateAndTime).toDate();
    let endtDateLocal = moment(endDateAndTime).toDate();

    const actions = [];

    const tabOnChange = (val) => {
        setSelectedTab(val);
    }

    const onCopyClicked = () => {
        setLoading(true);
        // Selected semester
        const payload = { semesterID: semester.id, currentCourseID: courseID, courseID: course.course_id, quizesIDs: selectedQuizIdArray, 
            // startDate: startDate, startTime: startTime, endDate: endDate, endTime: endTime,
             sectionIDs: selectSectionID };
        console.log('payload', payload)
        ApiRequestService({
            method: 'post',
            url: '/copyAllQuiz',
            data: payload
        })
            .then(res => {
                if (
                    res && res.data && res.data.data
                ) {
                    NotificationManager.success('Imported all assignments successfully!', 'Success', 3000);
                    //Redirect to the Quiz Page
                    if (fromMatrixPage) {
                        onCompleteCopyQuiz();
                    } else {
                        window.location.reload();
                    }
                }
            })
            .catch(error => {
                console.error('Error When Importing Quizes ', error);
                NotificationManager.error(error, "Error", 5000);
                setSemester([]);
                setCourse([]);
                setStartDateAndTime('');
                setEndDateAndTime('');
                setSelectedQuizIdArray([]);
                setSelectSectionID([]);
                setLoading(false);
                setQuizLoading(false);
                setSectionLoading(false);
                setCourseLoading(false);
                onHide();
            }).finally(() => {
                setLoading(false);
            });

    }

    const onHideandAll = () => {
        setSemester(null);
        setCourse(null);
        setStartDateAndTime('');
        setEndDateAndTime('');
        setSelectedQuizIdArray([]);
        setSelectSectionID([]);
        onHide();
    };

    const onCourseChange = (_, index) => {
        setCourse({ ...courses[index] });
        setSelectedQuizIdArray([]);
        setSelectSectionID([]);
        setStartDateAndTime('');
        setEndDateAndTime('');
    };

    //On Section Selected
    const onQuizChange = (argSelectedQuizIDs) => {
        let quizIds = []
        argSelectedQuizIDs.forEach(row => {
            if (row.value && row.id !== 'enableAll' && row.id !== 'enableNone') {
                quizIds.push(row.id);
            }
        })
        setSelectedQuizIds([...argSelectedQuizIDs])
        setSelectedQuizIdArray([...quizIds])
        console.log("selected section ", quizIds)
    };

    const onSectionChange = (argSelectedSectionIDs) => {
        let seletedSectionID = []
        argSelectedSectionIDs.forEach(row => {
            if (row.value && row.id !== 'enableAll' && row.id !== 'enableNone') {
                seletedSectionID.push(row.id);
            }
        })
        setSelectSectionID([...seletedSectionID])
    };

    const onSemesterChange = (_, index) => {
        setSemester({ ...semesters[index] });
        // emoty other dropdown data's
        setCourse([]);
        setStartDateAndTime('');
        setEndDateAndTime('');
        setSelectedQuizIdArray([]);
        setSelectSectionID([])
        console.log("semester changed", semester)
    };

    /* const getAllSemesters = () => {
         ApiRequestService({
                 method: 'post',
                 url: '/getAllSemesters'
             }).then(res => {
                 setSectionLoading(false);
 
                 if (res && res.data && res.data.data) {
                     setSemesters([...res.data.data]);
                 }
             })
             .catch(error => {
                 console.error('Error When Retriving Section Details ', error);
             });
         console.log("semesters = ", semesters)
     } */

    const getAllSemesters = async () => {
        let getAllSemestersResp = await ApiRequestService({
            method: 'post',
            url: '/getAllSemesters'
        });

        try {
            if (getAllSemestersResp && getAllSemestersResp.data && getAllSemestersResp.data.data) {
                return getAllSemestersResp.data.data;
            } else if (getAllSemestersResp.data && getAllSemestersResp.data.status && getAllSemestersResp.data.message) {
                NotificationManager.error("Get All Semesters Failed with Error - " + getAllSemestersResp.data.message, "Error", 5000);
            } else {
                NotificationManager.error("Get All Semesters Failed with Unknown Error", "Error", 5000);
            }
        } catch (err) {
            NotificationManager.error("Get All Semesters Failed with Error " + err, "Error", 5000);
        }

        return null;
    }

    const onload = () => {
        getAllSemesters().then(semesters => {
            if (semesters != undefined) {
                /* const semesters = semesters.map((semester,index)=>{
                    return {'name':semester.name,'id':semester.id,'isCurrent':semester.isCurrent};
                }); */
                const prevSemesters = semesters.filter(semester => semester.isCurrent != true);
                setSemesters([...prevSemesters]);
            }
        })
    }
    useEffect(onload, []);

    const getCoursesFromSemester = () => {
        if (semester) {
            setCourses([]);
            setCourseLoading(true);
            const payload = { id: semester.id };
            ApiRequestService({
                method: 'post',
                url: '/getAllCoursesForSemester',
                data: payload
            })
                .then(res => {
                    setCourseLoading(false);

                    if (res.data !== undefined && res.data !== null &&
                        res.data.data !== undefined && res.data.data !== null &&
                        res.data.data.course_names !== undefined &&
                        res.data.data.course_names !== null &&
                        res.data.data.course_names.length > 0) {
                        setCourses([...res.data.data.course_names]);
                    } else {
                        NotificationManager.error(
                        "You do not have access to view any courses in the selected semester.\n\nPlease contact your administrator to request access.",
                        "Access Denied",
                        6000
                        );
                    }
                })
                .catch(error => {
                    console.error('Error When Retriving Course Details ', error);
                });
        }
    };

    const getQuizsFromCourse = () => {
        if (course) {
            setQuizzes([]);
            setQuizLoading(true);
            const payload = { course_id: course.course_id, archiveMode: true, semesterID: semester.id };
            ApiRequestService({
                method: 'post',
                url: '/getAllQuiz',
                data: payload
            })
                .then(res => {
                    setQuizLoading(false);

                    if (res.data !== undefined && res.data !== null &&
                        res.data.data !== undefined && res.data.data !== null &&
                        res.data.data.quizes_list !== undefined &&
                        res.data.data.quizes_list !== null &&
                        res.data.data.quizes_list.length > 0) {
                        setQuizzes([...res.data.data.quizes_list]);
                    }
                })
                .catch(error => {
                    console.error('Error When Retriving Course Details ', error);
                });
        }
    };


    const getSections = () => {
        if (course) {
            setSections([]);
            setSectionsSelected([]);
            setSectionsArray([]);
            setSectionLoading(true);
            const payload = { course_id: courseID };
            ApiRequestService({
                method: 'post',
                url: '/getAllSections',
                data: payload
            })
                .then(res => {
                    setSectionLoading(false);

                    if (
                        res && res.data && res.data.data &&
                        res.data.data.section_names &&
                        res.data.data.section_names.length > 0
                    ) {
                        setSectionsArray([...res.data.data.section_names]);
                        const section_list = res.data.data.section_names.map((section, index) => {
                            return { 'label': section.section_name, 'id': index, 'value': false };
                        });
                        setSections(section_list);
                    } else {
                        NotificationManager.error("Please create atleast one section in your active course.");
                    }
                })
                .catch(error => {
                    console.error('Error When Retriving Section Details ', error);
                });
        }
    };




    // const onSectionSelect = (vals) => {
    //     const selectedValues = [];

    //     vals.forEach((section,index) => {
    //         if(section.value === true){
    //             selectedValues.push(sectionsArray[section.id].section_id);
    //         } 
    //     });

    //     setSections([...vals]);
    //     setSectionsSelected(selectedValues)
    // }

    const onSingleSectionSelected = (value) => {
        console.debug(value)
        const temp = sections.map(section => {
            var returnValue = { ...section, value: false };

            if (section.id === value) {
                returnValue.value = true;
            }
            return returnValue
        });
        setSections(temp)
        setSelectSectionID(value)
        setSectionsSelected([sectionsArray[value].section_id])
    }


    useEffect(() => {
        if (semester) {
            getCoursesFromSemester();
        }
    }, [semester]);
    useEffect(() => {
        if (course) {
            getQuizsFromCourse()
        }
    }, [course]);
    //Load Sections on Course Select
    useEffect(() => {
        if (course) {
            getSections();
        }
    }, [course]);

    //Reset on Dialog Load
    useEffect(() => {
        if (visible) {
            setLoading(false);
            setCourse(undefined);
            setSections([]);
            setSectionsArray([]);
        }
    }, [visible])

    const handleChangeStartDate = (timeString, sDate, event) => {
        if (sDate !== null) {
            setStartDateAndTime(moment(sDate))
            let tempDateandTime = moment(sDate).format('DD/MM/YYYY HH:mm').split(' ')
            setStartDate(tempDateandTime[0]);
            setStartTime(tempDateandTime[1]);
        }
    }

    const handleChangeEndDate = (timeString, eDate, event) => {
        if (eDate !== null) {
            setEndDateAndTime(moment(eDate))
            let tempDateandTime = moment(eDate).format('DD/MM/YYYY HH:mm').split(' ')
            setEndDate(tempDateandTime[0]);
            setEndTime(tempDateandTime[1]);
        }
    }

    //Buttons
    actions.push({ secondary: true, children: 'Cancel', onClick: onHideandAll });
    actions.push(<Button raised primary onClick={onCopyClicked} disabled={!course || !selectSectionID || selectSectionID.length <= 0 || loading} >Import</Button>);

    return <DialogContainer
        id="copy-all-quiz-dialog"
        title="Import Assignments"
        visible={visible}
        onHide={onHide}
        contentClassName="md-grid copy-quiz-dialog"
        aria-describedby="copy-quiz-instructions"
        modal
        actions={actions}
        width={'70%'}
    >
        {
            loading ?
                <React.Fragment>
                    <Cell size={12} > <LoadingSpinner cls={{ margin: '10%' }} loading={loading} /> </Cell>
                </React.Fragment>

                :

                <React.Fragment>

                    <CustomSegmentedControl
                        options={labels}
                        setValue={(newValue) => tabOnChange(newValue)}
                        style={{
                            ...styles.categorySegmentedControl,
                            width: "100%",
                        }}
                    />
                    {selectedTab === "from_previous_semester" ?
                        <Grid style={{ margin: "1rem 0rem", padding: "0" }}>
                            <Cell size={12} id="copy-quiz-instructions" className='md-body-4'>
                                Please select a semester, a course and one or more assignments under it, and finally, import the assignments to sections
                            </Cell>
                            <Cell size={6}>
                                <CardTitle style={{ padding: '0px', fontSize: '13px' }}>Semester</CardTitle>
                                <SelectField
                                    id="selectSemesters"
                                    placeholder="Select Semester"
                                    itemLabel="name"
                                    itemValue="id"
                                    menuItems={semesters}
                                    onChange={onSemesterChange}
                                    fullWidth
                                />
                            </Cell>
                            <Cell size={6}>
                                {
                                    courseLoading ?
                                        <LoadingSpinner cls={{ margin: '10%' }} loading={courseLoading} />
                                        :

                                        courses.length > 0 ?
                                            <>
                                                <CardTitle style={{ padding: '0px', fontSize: '13px' }}>Course</CardTitle>
                                                <SelectField
                                                    id="selectCourses"
                                                    placeholder="Select Course"
                                                    itemLabel="course_name"
                                                    itemValue="course_id"
                                                    menuItems={courses}
                                                    onChange={onCourseChange}
                                                    fullWidth
                                                />
                                            </>
                                            :
                                            undefined
                                }
                            </Cell>

                            <Cell size={12}>
                                {
                                    quizLoading ?
                                        <LoadingSpinner cls={{ margin: '10%' }} loading={quizLoading} />
                                        :

                                        quizzes.length > 0 && (course && course != []) ?
                                            <>
                                                <CardTitle style={{ padding: '0px', marginBottom: '8px', fontSize: '13px' }}>Assignments</CardTitle>
                                                <QuizDropDown
                                                    NoLoader={true}
                                                    selectedCourseID={course}
                                                    selectedSemesterID={semester.id}
                                                    selectBoxID="sectionSelectBox"
                                                    placeholder="Select Assignments"
                                                    fullWidth
                                                    archiveMode={true}
                                                    onChange={onQuizChange}
                                                    className=" gradebook-dropdown"
                                                    selectAll={false}
                                                    showSelectAll={true}
                                                    perfDataMode={true} />
                                            </>
                                            :
                                            undefined
                                }
                            </Cell>
                            <Cell size={12}>
                                {
                                    sectionLoading ?
                                        <LoadingSpinner cls={{ margin: '10%' }} loading={sectionLoading} />
                                        :

                                        sections.length > 0 && selectedQuizIdArray.length > 0 ?
                                            <React.Fragment>
                                                {/* {appProperties.enableLTI? */}
                                                <CardTitle style={{ padding: '0px', marginBottom: '10px', fontSize: '13px' }}>Pick one or more sections to import the chosen assignments</CardTitle>
                                                <SectionDropDown
                                                    NoLoader={true}
                                                    selectedCourseID={courseID}
                                                    selectedSemesterID={sectionsSelected}
                                                    selectBoxID="sectionSelectBox"
                                                    placeholder="Select   Section"
                                                    fullWidth
                                                    // sectionMap={this.state.sectionMap}
                                                    onChange={onSectionChange}
                                                    className=" gradebook-dropdown"
                                                    selectAll={false} />
                                                {/*   :
                                        <MultiSelectReact
                                        options={sections}
                                        selectedOptionsStyles={selectedOptionsStyles}
                                        optionsListStyles={optionsListStyles}
                                        enableSelectAllNone={false}
                                        optionClicked={onSectionSelect}
                                        selectedBadgeClicked={onSectionSelect}
                                        enableSelectAllNone={true}
                                        />} */}
                                            </React.Fragment> :
                                            undefined
                                }
                            </Cell>
                            {/* <Cell position={'left'} size={12}>
                                {selectSectionID.length > 0 ?
                                    <CardTitle style={{ padding: '0px', marginBottom: '-30px', fontSize: '13px' }}>All assignments that are currently being imported will have the new start and end times you pick below</CardTitle> : undefined}
                            </Cell> */}
                            <Cell position={'left'} size={12}>
                                {selectSectionID.length > 0 ?
                                    <CardTitle style={{ padding: '0px', marginBottom: '-30px', fontSize: '13px' }}>
                                       NOTE:  All assignments being imported will have no start or end dates assigned and will remain unpublished.
                                    </CardTitle> : undefined}
                            </Cell>

                            {/* <Cell size={3} phoneSize={2} tabletSize={4}>
                                {selectSectionID.length > 0 ? <DatePicker
                                    id="startDate"
                                    label="Start Date"
                                    displayMode="portrait"
                                    value={isValidDate(startDateLocal) ? startDateLocal : null}
                                    onChange={handleChangeStartDate}
                                    lastChild
                                    renderNode={null}
                                    disableScrollLocking
                                /> : undefined
                                }
                            </Cell>
                            <Cell size={3} phoneSize={2} tabletSize={4}>
                                {selectSectionID.length > 0 ? <TimePicker
                                    id="startTime"
                                    label="Start Time"
                                    displayMode="portrait"
                                    value={isValidDate(startDateLocal) ? startDateLocal : null}
                                    onChange={handleChangeStartDate}
                                    lastChild
                                    renderNode={null}
                                    disableScrollLocking

                                /> : undefined}
                            </Cell>
                            <Cell size={3} phoneSize={2} tabletSize={4}>
                                {selectSectionID.length > 0 ? <DatePicker
                                    id="endDate"
                                    label="End Date"
                                    displayMode="portrait"
                                    value={isValidDate(endtDateLocal) ? endtDateLocal : null}
                                    onChange={handleChangeEndDate}
                                    lastChild
                                    renderNode={null}
                                    disableScrollLocking
                                /> : undefined}

                            </Cell>
                            <Cell size={3} phoneSize={2} tabletSize={4}>
                                {selectSectionID.length > 0 ? <TimePicker
                                    id="endTime"
                                    label="End Time"
                                    displayMode="portrait"
                                    value={isValidDate(endtDateLocal) ? endtDateLocal : null}
                                    onChange={handleChangeEndDate}
                                    lastChild
                                    renderNode={null}
                                    disableScrollLocking

                                /> : undefined}
                            </Cell> */}
                        </Grid>
                        : null}

                </React.Fragment>
        }
    </DialogContainer>
};

export default CopyAllQuizDialog;